import { Fragment, useState } from 'react'
import {
  Box,
  Button,
  Collapse,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
  Typography
} from '@mui/material'
import { makeStyles, styled } from '@mui/styles'
import CloseIcon from '@mui/icons-material/Close'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import DevicesIcon from '@mui/icons-material/Devices'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { formatter } from '../../utils/auxFunc'

const steps = ['ENVÍO', 'PAGO', 'RESUMEN']

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiStepConnector-root': {
      top: '18px',
      left: 'calc(-50% + 25px)',
      right: 'calc(50% + 25px)'
    },
    '& .MuiSvgIcon-root.MuiStepIcon-root': { width: '1.4em', height: '1.4em' },
    '& .MuiStepIcon-root.Mui-active': {
      color: '#292929',
      border: '1px solid #292929',
      borderRadius: '50%',
      '& .MuiStepIcon-text': {
        fill: '#FAFAFA'
      }
    },
    '& .MuiStepIcon-root.Mui-completed': {
      color: '#9b9797',
      border: '1px solid #9b9797',
      borderRadius: '50%'
    },
    '& .Mui-disabled .MuiStepIcon-root': {
      color: '#FAFAFA',
      border: '1px solid #9b9797',
      borderRadius: '50%'
    }
  }
}))

const CheckoutRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.secondary.main
  }
}))

const ExpandMore = styled((props) => {
  const { expand, ...other } = props
  return <IconButton {...other} />
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  padding: '0 0.5rem',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  })
}))
const PaymentInfo = ({
  shipmentCost,
  banks,
  paymentMethods,
  closeCheckout,
  paymentForm,
  setPaymentForm,
  getTotalAmount,
  activeStep,
  handleBack,
  handleNext,
  shipmentForm
}) => {
  const [expanded, setExpanded] = useState(false)
  const classes = useStyles()

  const handleRadio = (evt) => {
    setPaymentForm(JSON.parse(evt.target.value))
  }

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const payment = {
    transferencia: 2,
    mercadopago: 12
  }

  const shipmentMessage = () => {
    if (shipmentForm.shipmentOption === 'caba') return 'Envío bonificado'
    else return 'Envío bonificado hasta transporte'
  }

  return (
    <Fragment>
      <Box
        display="flex"
        minHeight="64px"
        sx={{ backgroundColor: (theme) => theme.palette.secondary.main }}
      >
        <Typography
          variant="h5"
          color="primary"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexGrow={1}
        >
          Checkout
        </Typography>

        <Box sx={{ position: 'absolute', right: '1rem', top: '.3rem' }}>
          <Tooltip title="Carrito">
            <IconButton
              size="large"
              aria-label="carrito"
              aria-controls="logo-carrito"
              aria-haspopup="false"
              color="inherit"
              onClick={closeCheckout}
            >
              <CloseIcon color="primary" sx={{ fontSize: '2rem' }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <Box
        minHeight="calc(100vh - 64px)"
        sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
      >
        <Container
          sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
        >
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{ padding: '1.5rem 0' }}
            className={classes.root}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Typography
            variant="subtitle1"
            color={(theme) => theme.palette.light.main}
            sx={{
              fontSize: '1rem'
            }}
          >
            Método de pago:
          </Typography>
        </Container>
        <Container
          sx={{
            marginTop: '1rem',
            marginBottom: '1rem',
            backgroundColor: '#FFF'
          }}
        >
          <FormControl fullWidth>
            <RadioGroup
              aria-labelledby="Selección método de pago"
              defaultValue=""
              name="Método de pago"
              onChange={handleRadio}
            >
              {paymentMethods?.map((method) => {
                if (method.idPaymentCondition === payment.transferencia) {
                  return (
                    <Fragment key={method.idPaymentCondition}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <AccountBalanceIcon />
                        <FormControlLabel
                          value="transferencia"
                          control={
                            <Box
                              display="flex"
                              alignItems="center"
                              onClick={handleExpandClick}
                            >
                              <ExpandMore
                                expand={expanded}
                                aria-expanded={expanded}
                                aria-label="detalle bancos"
                              >
                                <ExpandMoreIcon
                                  style={{ paddingRight: '1px' }}
                                />
                              </ExpandMore>
                            </Box>
                          }
                          label={
                            // paymentForm.paymentMethod ===
                            // method.idPaymentCondition
                            // 	? `Transferencia - ${paymentForm.bankName}`
                            // 	: method.description
                            method.description
                          }
                          labelPlacement="start"
                          sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginLeft: '.5rem',
                            textTransform: 'capitalize'
                          }}
                        />
                      </Box>
                      <Collapse
                        in={expanded}
                        timeout="auto"
                        unmountOnExit
                        sx={{ width: '100%', marginTop: '0.5rem' }}
                      >
                        <Container sx={{ marginBottom: '0.5rem' }}>
                          <Typography>Titular: GRUPO MONACO SRL</Typography>
                          <Typography>Cuit: 30-71606701-3</Typography>
                        </Container>
                        {banks?.map((bank) => (
                          <Fragment key={bank.bankId}>
                            <Divider />
                            <FormControlLabel
                              value={JSON.stringify({
                                paymentMethod: method.idPaymentCondition,
                                paymentDescription: method.description,
                                bankId: bank.bankId,
                                bankName: bank.bankName
                              })}
                              checked={paymentForm.bankId === bank.bankId}
                              control={
                                <CheckoutRadio
                                  sx={{
                                    '&.Mui-checked': {
                                      color: '#292929'
                                    }
                                  }}
                                />
                              }
                              label={
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    textTransform: 'capitalize'
                                  }}
                                >
                                  {bank.bankName}
                                </Typography>
                              }
                              labelPlacement="start"
                              sx={{
                                flex: 1,
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginLeft: '.5rem'
                              }}
                            />
                            <Container>
                              <Typography sx={{ textTransform: 'capitalize' }}>
                                {bank.bankAccountType}
                              </Typography>
                              <Typography>
                                N° de cuenta: {bank.bankAccountNumber}
                              </Typography>
                              <Typography>CBU: {bank.bankCBUNumber}</Typography>
                              <Box
                                sx={{ display: 'flex', paddingBottom: '10px' }}
                              >
                                <Typography>Alias: </Typography>
                                <Typography
                                  sx={{
                                    textTransform: 'uppercase',
                                    paddingLeft: '5px'
                                  }}
                                >
                                  {bank.bankAlias}
                                </Typography>
                              </Box>
                            </Container>
                          </Fragment>
                        ))}
                      </Collapse>
                    </Fragment>
                  )
                }

                if (method.idPaymentCondition === payment.mercadopago) {
                  return (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      key={method.idPaymentCondition}
                    >
                      <DevicesIcon />
                      <FormControlLabel
                        value={JSON.stringify({
                          paymentMethod: method.idPaymentCondition,
                          paymentDescription: method.description,
                          bankId: null,
                          bankName: null
                        })}
                        checked={
                          paymentForm.paymentMethod ===
                          method.idPaymentCondition
                        }
                        control={
                          <CheckoutRadio
                            sx={{
                              '&.Mui-checked': {
                                color: '#292929'
                              }
                            }}
                          />
                        }
                        label={method.description}
                        labelPlacement="start"
                        sx={{
                          flex: 1,
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginLeft: '.5rem'
                        }}
                      />
                    </Box>
                  )
                }

                return (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    key={method.idPaymentCondition}
                  >
                    <AccountBalanceWalletOutlinedIcon />
                    <FormControlLabel
                      value={JSON.stringify({
                        paymentMethod: method.idPaymentCondition,
                        paymentDescription: method.description,
                        bankId: null,
                        bankName: null
                      })}
                      checked={
                        paymentForm.paymentMethod === method.idPaymentCondition
                      }
                      control={
                        <CheckoutRadio
                          sx={{
                            '&.Mui-checked': {
                              color: '#292929'
                            }
                          }}
                        />
                      }
                      label={method.description}
                      labelPlacement="start"
                      sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginLeft: '.5rem'
                      }}
                    />
                  </Box>
                )
              })}
              {paymentForm.paymentMethod === payment.mercadopago && (
                <Container>
                  <Divider />
                  <Typography sx={{ marginTop: '0.5rem' }}>
                    CVU: 0000003100070887928564
                  </Typography>
                  <Typography sx={{ marginBottom: '0.5rem' }}>
                    Alias: GrupoMonaco.mp
                  </Typography>
                  <Divider />
                </Container>
              )}
            </RadioGroup>
          </FormControl>
        </Container>
        <Container
          sx={{
            backgroundColor: (theme) => theme.palette.lightBg.main,
            paddingTop: '1rem'
          }}
        ></Container>
        <Container
          sx={{
            padding: '1rem ',
            backgroundColor: '#FFF'
          }}
        >
          <Typography variant="subtitle1" color="initial">
            {`Si desea transferir su compra, recuerde que debe hacerse desde una
						cuenta en la que usted sea Titular y a su vez retirar el producto
						usted mismo. En el caso de que se reciba transferencia de otra
						persona que no es la que retira; necesitaríamos que nos envíe una
						autorización y foto de DNI de la persona que emitió la
						transferencia.
						Muchas gracias!`}
          </Typography>
        </Container>

        <Container
          sx={{
            backgroundColor: (theme) => theme.palette.lightBg.main,
            minHeight: 'calc(100vh - 635px)'
          }}
        ></Container>
        <Box
          py={2}
          sx={{
            position: 'relative',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: '#FFF'
          }}
        >
          <Container>
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                Subtotal:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem'
                }}
              >
                {formatter().format(getTotalAmount())}
              </Typography>
            </Box>
            {shipmentForm.shipmentOption !== 'sucursal' && (
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem'
                  }}
                >
                  Envío
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem'
                  }}
                >
                  {shipmentCost.shipmentCost === 0
                    ? shipmentMessage()
                    : formatter().format(
                        shipmentCost.shipmentCost * shipmentCost.dolarValue
                      )}
                  {shipmentForm.shipmentOption === 'interior' && ' *'}
                </Typography>
              </Box>
            )}
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem',
                  fontWeight: '600'
                }}
              >
                Total:
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1rem',
                  fontWeight: '600'
                }}
              >
                {shipmentForm.shipmentOption === 'sucursal'
                  ? formatter().format(getTotalAmount())
                  : formatter().format(
                      getTotalAmount() +
                        shipmentCost.shipmentCost * shipmentCost.dolarValue
                    )}
              </Typography>
            </Box>
            {shipmentForm.shipmentOption === 'interior' && (
              <Box>
                <Typography variant="caption">
                  * Debera abonar el costo desde el transporte hasta su
                  domicilio en la empresa que haya seleccionado
                </Typography>
              </Box>
            )}
          </Container>
          <Container
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '1rem',
              paddingBottom: '1.5rem'
            }}
          >
            <Button
              color="secondary"
              variant="outlined"
              sx={{
                width: '45%',
                textTransform: 'capitalize',
                fontSize: '1rem'
              }}
              onClick={handleBack}
            >
              Anterior
            </Button>
            <Button
              color="secondary"
              variant="contained"
              disableElevation
              sx={{
                width: '45%',
                textTransform: 'capitalize',
                fontSize: '1rem'
              }}
              onClick={handleNext}
            >
              Siguiente
            </Button>
          </Container>
        </Box>
      </Box>
    </Fragment>
  )
}

export default PaymentInfo
